import { getJWTClaims } from './config';

export type SessionStatus = 'active' | 'expiring' | 'expired' | 'no-expiry';

/** JWT `exp` claim in epoch SECONDS, or null when absent (anon key / dev). */
export function getTokenExp(): number | null {
  const exp = getJWTClaims()?.exp;
  return typeof exp === 'number' ? exp : null;
}

/**
 * Derive session status. `bufferSeconds` is the proactive warning window
 * before the hard expiry instant.
 */
export function getSessionStatus(
  nowMs: number = Date.now(),
  bufferSeconds: number = 120,
): SessionStatus {
  const exp = getTokenExp();
  if (exp === null) return 'no-expiry';
  const expMs = exp * 1000;
  if (nowMs >= expMs) return 'expired';
  if (expMs - nowMs <= bufferSeconds * 1000) return 'expiring';
  return 'active';
}

/** Seconds until expiry (floored), or null when there is no expiry. */
export function secondsUntilExpiry(nowMs: number = Date.now()): number | null {
  const exp = getTokenExp();
  if (exp === null) return null;
  return Math.floor((exp * 1000 - nowMs) / 1000);
}
